module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av285-938169b55d881962bb327e9b2192519a.jpg";